/* =====================================================================================
   mm-micro-conversions.js — Maison Miaous — posé le 2026-10-29
   -------------------------------------------------------------------------------------
   POURQUOI : la formation (live Moneeb ≈ 1:08:45) demande des micro-conversions
   « vue produit, panier, paiement initié » pour « nourrir l'algorithme et repérer la fuite ».
   Les 3 actions existent dans Google Ads depuis le 29-10 (secondaires, sans valeur €) :
       Vue produit      7881733378  AW-18488349271/cmEACILqpq4dENek9-9E
       Ajout au panier  7881733381  AW-18488349271/VUN6CIXqpq4dENek9-9E
       Paiement initié  7881733384  AW-18488349271/slWVCIjqpq4dENek9-9E

   POURQUOI PAS DANS GTM : le conteneur GTM-MHL9HR59 que charge le site n'est accessible
   depuis AUCUN de nos comptes Google (mohamed.ecomm2025@gmail.com et
   pousettechienfidelle@gmail.com : « Compte introuvable », 0 conteneur, vérifié le 29-10).
   On ne peut donc pas y ajouter de balise. Ce fichier contourne GTM : il parle à Google Ads
   en direct, depuis la page, sans toucher au conteneur ni à la conversion « Achat ».

   ⚠️ L'ACHAT N'EST PAS ICI. La conversion « Achat » (macro, valeur dynamique, conversions
   améliorées) reste servie par GTM sur l'événement `purchase` du pixel. Rien n'est dupliqué :
   les 4 libellés sont distincts.

   CONSENTEMENT : Consent Mode v2, par défaut REFUSÉ, mis à jour quand le visiteur choisit.
   Même traduction que le pixel (marketingAllowed → ad_storage / ad_personalization,
   saleOfDataAllowed → ad_user_data, analyticsProcessingAllowed → analytics_storage).
   ===================================================================================== */
(function () {
  'use strict';

  var AW = 'AW-18488349271';
  var MICRO = {
    view_item: 'cmEACILqpq4dENek9-9E',        // 7881733378  vue produit
    add_to_cart: 'VUN6CIXqpq4dENek9-9E',      // 7881733381  ajout au panier
    begin_checkout: 'slWVCIjqpq4dENek9-9E',   // 7881733384  paiement initie
    view_cart: 'EIYYCPzuo64dENek9-9E',        // 7881684860  panier consulte
    scroll_50: 'eXEKCP_uo64dENek9-9E',        // 7881684863  fiche lue a 50 %
    temps_30s: 'BN40CILvo64dENek9-9E',        // 7881684866  30 s sur la fiche
    search: 'x4q4CLOLrK4dENek9-9E'            // 7881819571  recherche interne
  };

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }

  function etatConsent(cp) {
    cp = cp || {};
    var mk = cp.marketingAllowed === true;
    var an = cp.analyticsProcessingAllowed === true;
    var sd = cp.saleOfDataAllowed === true;
    return {
      ad_storage: mk ? 'granted' : 'denied',
      ad_user_data: sd ? 'granted' : 'denied',
      ad_personalization: mk ? 'granted' : 'denied',
      analytics_storage: an ? 'granted' : 'denied'
    };
  }

  var cpInit = (window.Shopify && window.Shopify.customerPrivacy) || null;
  var etat = cpInit ? {
    marketingAllowed: cpInit.marketingAllowed && cpInit.marketingAllowed(),
    analyticsProcessingAllowed: cpInit.analyticsProcessingAllowed && cpInit.analyticsProcessingAllowed(),
    saleOfDataAllowed: cpInit.saleOfDataAllowed && cpInit.saleOfDataAllowed()
  } : {};
  gtag('consent', 'default', Object.assign({ wait_for_update: 500 }, etatConsent(etat)));

  // gtag.js pour Google Ads
  var s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + AW;
  document.head.appendChild(s);
  gtag('js', new Date());
  gtag('config', AW, { send_page_view: false });

  // le visiteur choisit -> on met a jour
  document.addEventListener('visitorConsentCollected', function (e) {
    gtag('consent', 'update', etatConsent((e && e.detail) || {}));
  });

  // une meme micro n'est comptee qu'une fois par page
  var deja = {};
  function micro(nom) {
    if (!MICRO[nom] || deja[nom]) return;
    deja[nom] = true;
    gtag('event', 'conversion', { send_to: AW + '/' + MICRO[nom] });
  }
  window.mmMicro = micro;   // pour la verification manuelle

  // ---------- 1. VUE PRODUIT ----------
  if (/^\/products\//.test(window.location.pathname)) micro('view_item');

  // ---------- 2. AJOUT AU PANIER ----------
  // Shopify passe TOUJOURS par /cart/add(.js) : on ecoute la ROUTE, pas un bouton,
  // pour ne dependre d'aucune classe du theme (une classe change, une route non).
  var fetchOrigine = window.fetch;
  if (typeof fetchOrigine === 'function') {
    window.fetch = function (entree) {
      var url = '';
      try { url = typeof entree === 'string' ? entree : (entree && entree.url) || ''; } catch (e) {}
      var p = fetchOrigine.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) { if (r && r.ok) micro('add_to_cart'); }).catch(function () {});
      }
      return p;
    };
  }
  var xhrOrigine = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
  if (xhrOrigine) {
    window.XMLHttpRequest.prototype.open = function (methode, url) {
      try {
        if (/\/cart\/add(\.js)?(\?|$)/.test(url || '')) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300) micro('add_to_cart');
          });
        }
      } catch (e) {}
      return xhrOrigine.apply(this, arguments);
    };
  }
  // formulaire classique (sans JavaScript du theme)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && /\/cart\/add/.test(f.action)) micro('add_to_cart');
  }, true);

  // ---------- 3. PAIEMENT INITIE ----------
  // tout ce qui emmene vers /checkout : bouton du panier, du tiroir, achat express
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('a,button,input[type=submit]') : null;
    if (!el) return;
    var href = (el.getAttribute && el.getAttribute('href')) || '';
    var nom = (el.getAttribute && el.getAttribute('name')) || '';
    if (/\/checkout/.test(href) || nom === 'checkout') micro('begin_checkout');
  }, true);

  // ---------- 4. PANIER CONSULTE ----------
  // la page panier, et le tiroir qui s'ouvre sans changer d'URL
  if (/^\/cart(\/|$)/.test(window.location.pathname)) micro('view_cart');
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('a,button') : null;
    if (!el) return;
    var h = (el.getAttribute && el.getAttribute('href')) || '';
    var aria = (el.getAttribute && (el.getAttribute('aria-controls') || el.getAttribute('aria-label'))) || '';
    if (/^\/cart(\?|$)/.test(h) || /cart-drawer|panier/i.test(aria)) micro('view_cart');
  }, true);

  // ---------- 5, 6. LA FICHE EST-ELLE VRAIMENT LUE ? ----------
  // Mesuré le 29-10 : 24 s de temps ACTIF et 45 % de défilement moyen pour 0 panier sur
  // 285 clics payés. Ces deux mesures séparent le curieux de l'intéressé — c'est leur
  // seule raison d'être. Le temps ne court QUE si l'onglet est au premier plan.
  if (/^\/products\//.test(window.location.pathname)) {
    // ⚠️ 29-10 : ce thème NE fait PAS défiler la fenêtre sur grand écran — c'est un conteneur
    // interne (`div.page-wrapper`, 4 975 px de contenu pour 846 px visibles) ; sur mobile c'est
    // la page. Un écouteur posé sur `window` ne serait donc JAMAIS parti sur ordinateur.
    // D'où l'écoute en phase de CAPTURE sur le document : elle attrape le défilement de
    // n'importe quel élément, et on mesure CELUI QUI a défilé. Trouvé en actionnant, pas en lisant.
    //
    // ⚠️ 29-10, 2e passe : la capture attrape AUSSI les blocs défilants internes (fenêtre
    // pop-up, carrousel, accordéon). Faire défiler une pop-up plus haute que l'écran aurait
    // compté « fiche lue à 50 % » alors que la fiche n'a pas bougé — un faux signal envoyé à
    // l'algorithme, donc pire que pas de signal. Mesuré ce jour : la boîte de la roue fait
    // 507 px sur 507 (PC) et 712 sur 712 (mobile), donc rien ne casse AUJOURD'HUI ; c'est un
    // hasard de contenu, pas une garantie. On ne compte donc QUE le défileur principal.
    function scrollerPrincipal() {
      var w = document.querySelector('div.page-wrapper');     // grand écran
      if (w && w.scrollHeight - w.clientHeight > 0) return w;
      return document.scrollingElement || document.documentElement;   // mobile
    }
    var defilementFait = false;
    document.addEventListener('scroll', function (e) {
      if (defilementFait) return;
      var principal = scrollerPrincipal();
      var el = e.target;
      if (!el || el === document || el === document.documentElement || el === document.body) {
        el = principal;
      }
      if (el !== principal) return;        // un bloc défilant interne ne compte pas
      var h = el.scrollHeight - el.clientHeight;
      if (h <= 0) return;
      if (el.scrollTop / h >= 0.5) { defilementFait = true; micro('scroll_50'); }
    }, true);

    var secondes = 0;
    var horloge = setInterval(function () {
      if (document.visibilityState !== 'visible') return;   // onglet en arriere-plan = ne compte pas
      secondes += 1;
      if (secondes >= 30) { micro('temps_30s'); clearInterval(horloge); }
    }, 1000);
  }

  // ---------- 7. RECHERCHE INTERNE ----------
  if (/^\/search/.test(window.location.pathname) && /[?&]q=[^&]/.test(window.location.search)) micro('search');
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && /\/search/.test(f.action)) micro('search');
  }, true);
})();
